import { Subscriptions, subscriptions } from ".";

// declare subscriptions on the window object
declare global {
    interface Window {
        subscriptions: Subscriptions;
    }
}

window.subscriptions = subscriptions;

export default subscriptions;